import { createContext } from 'react';

/** How long a scheduled action stays undoable before it commits for real. */
export const UNDO_WINDOW_MS = 6000;

/**
 * A write the user can take back. Nothing reaches the API until the undo
 * window closes, so `onUndo` is always local state only — there is no
 * compensating call to make.
 */
export interface UndoableAction {
  /** Quoted in the toast: `"Spring blend" deleted`. Keep it short. */
  label: string;
  /** Past-tense verb for the toast line. Defaults to `deleted`. */
  verb?: string;
  /** The real write. Fires when the window closes, never before. */
  onCommit: () => Promise<void>;
  /** Put the row back. No write has happened yet. */
  onUndo: () => void;
  /** The commit failed: restore the row and surface the message. */
  onFailure?: (error: unknown) => void;
}

export interface UndoToastContextValue {
  /** Schedules an action and returns the pending id that identifies it. */
  schedule: (action: UndoableAction) => string;
  /** Commits a pending action now — dismiss, unmount, or page teardown. */
  commitNow: (id: string) => void;
}

export const UndoToastContext = createContext<UndoToastContextValue | undefined>(undefined);
